module.exports = __webpack_public_path__ + "static/homeland-fa1438f0509f78bb31a2dee30704cd82.jpg";